import styled from "styled-components";
import {Section as SectionStyles,BtnFlex, Btn,BtnLink, BtnSmall, Container as ContainerStyles, Grid, SectionSubTitle, SectionTitle} from '../ReUsableStyles';

export const Section = styled.section`
    ${SectionStyles};
`;
export const Title = styled.h2`
    ${SectionTitle};
`;
export const Subtitle = styled.span`
    ${SectionSubTitle};
`;
export const Container = styled.div`
    ${ContainerStyles};
    ${Grid};
    gap: 1.5rem;
    grid-template-columns:repeat(2, 1fr);
`;

export const Content = styled.div`
    position: relative;
    background-color: var(--container-color);
    padding: 3.5rem .5rem 1.25rem 1.5rem;
    border-radius: .25rem;
    box-shadow: 0 2px 4px rgba(0,0,0,.15);
    transition: .3s;
    &:hover{
        box-shadow: 0 4px 8px rgba(0,0,0,.15);
    }
    .service-icon{
        display: block;
        color: var(--first-color);
        margin-bottom: var(--mb-1);
    }
`;

export const ServicesTitle = styled.h3`
    font-size: var(--h3-font-size);
    margin-bottom: var(--mb-1);
    font-weight: var(--font-medium);
`;

export const ServicesBtn = styled.span`
    ${Btn};
    ${BtnSmall};
    ${BtnLink};
    ${BtnFlex};
    font-size: var(--small-font-size);
    &:hover{
        .btn__icon{
            transform: translateX(.25rem);
        }
    }
`;

export const ServicesModal = styled.div`
    position: fixed;
    top:0;
    left:0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0, .5);
    display:flex;
    align-items: center;
    justify-content: center;
    padding: 0 1rem;
    z-index: var(--z-modal);
    opacity: ${(props)=>!props.open && "0"};
    visibility: ${(props)=>!props.open && "hidden"};
    transition: .3s;
`;

export const ModalContent = styled.div`
    position: relative;
    background-color: var(--container-color);
    padding: 1.5rem;
    border-radius: .5rem;

    .modal-close{
        position: absolute;
        top:1rem;
        right:1rem;
        font-size: 1.5rem;
        color: var(--first-color);
        cursor:pointer;
    }
`;

export const ModalTitle = styled.h4`
    font-size: var(--h3-font-size);
    font-weight: var(--font-medium);
    margin-bottom: var(--mb-1-5);
`;

export const ModalList = styled.ul`
    ${Grid};
    row-gap: 1rem;
`;

export const ListItem = styled.li`
    display: flex;
    .modal-icon{
        color: var(--first-color);
        margin-right: var(--mb-0-25);
    }
`;